import { c as _c } from "react/compiler-runtime";
import { HotelCard } from "@website/accommodation-ui/hotel-card-new";
import { HotelLastSecondCityPagePropertiesTypes } from "@website/accommodation-ui/hotel-last-second/hotel-last-second-city-page/hotel-last-second-city-page.type";
import { CarouselV2 } from "@website/ui/carousel";
import { Skeleton } from "@website/ui/skeleton";
import { today, tomorrow } from "@website/utils/date-format";
import set from "lodash-es/set";
import toString from "lodash-es/toString";
import { useRouter } from "next/router";
import { FC } from "react";
import { HotelLastSecondDiscountBox } from "../hotel-last-second-new-design";
export const HotelLastSecondCityPage: FC<HotelLastSecondCityPagePropertiesTypes> = t0 => {
  const $ = _c(6);
  const {
    lastSecondHotels,
    loading,
    cityTitle
  } = t0;
  const router = useRouter();
  if (router.query.promotion || !lastSecondHotels?.length || ![today(), tomorrow()].includes(toString(router.query.date_from))) {
    return;
  }
  const totalSlides = (lastSecondHotels?.length || 0) + 1;
  const isFewSlides = totalSlides < 4;
  let t1;
  if ($[0] !== cityTitle || $[1] !== isFewSlides || $[2] !== lastSecondHotels || $[3] !== loading || $[4] !== totalSlides) {
    t1 = <div className="bg-transparent-primary border-transparent-primary mx-[-24px] flex flex-col gap-4 border-y px-6 py-4 xl:mx-0 xl:rounded-xl xl:border">{loading ? <div className="flex flex-col gap-4"><Skeleton className="!w-full" height={118} shape="rectangle" /></div> : <><div className="h-auto"><CarouselV2 itemClass="max-w-[280px]" sectionClassName={` ${isFewSlides ? "flex gap-4 overflow-x-auto" : ""}`} keyCarousel={`last_sec_carousel_${cityTitle}`} mode="free-snap" options={{
            slides: {
              perView: isFewSlides ? totalSlides : "auto",
              spacing: 8
            },
            disabled: isFewSlides
          }} list={[<HotelLastSecondDiscountBox size="small" loading={loading} />, ...(lastSecondHotels?.map((hotel, index) => <HotelCard index={index} hotelInfo={set(hotel, "hotelDetail.hotelPageUrl.query.utm_source", "last_second_hotels")} key={hotel.id} loading={loading} isSuggestedCard={true} size="xSmall" />) || [])]} /></div></>}</div>;
    $[0] = cityTitle;
    $[1] = isFewSlides;
    $[2] = lastSecondHotels;
    $[3] = loading;
    $[4] = totalSlides;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};